import { isNil } from 'lodash'

/**
 * This util handle the persistance of the search query used in almost all the table ( devices, programs ...)
 *
 * In this file we expose a name for the globalSearchQuery,
 * this const is used as the default storage key if none is provided.
 *
 * It also provide getter and setter for the content of this search query. The getter/setter logic aims
 * at ensuring we can have multiple tabs opended on the dashboard and each instance of the dashboard will
 * have an isolated lifecycle for the search query content.
 *
 * If I open the dashboard (instance1), search for devices with query "gallerie",
 * then switch to the programs, the query must stay "gallerie"
 *
 * If I open a new dashboard ( another tab / instance2 ), the search query must be "gallerie" by default,
 * if I change the search query to be "rooftop" two things need to happend:
 * - the new persistent query in instance2 must be rooftop and I can changes itemlist it stays "rooftop"
 * - in instance1 the query must still be "gallerie" and I can changes items lists, it stays "gallerie"
 *
 * If I open a new instance of the dashboard, then the default search query will be "rooftop"
 */

export const GENERIC_SEARCH_STORAGE_KEY = 'genericSearchQuery'

const cache: { [key: string]: string | null } = {}

export const getPersistentSearchQuery = (
	key: string = GENERIC_SEARCH_STORAGE_KEY
): string => {
	// only for the first call for this key in the app lifecycle
	const cached = cache[key]
	if (!isNil(cached)) {
		return cached
	}

	const query = localStorage.getItem(key) ?? ''
	cache[key] = query
	return query
}

export const setPersistentSearchQuery = (
	key: string = GENERIC_SEARCH_STORAGE_KEY,
	query: string
): void => {
	// update the cache, so the next time we get the query in the instance, we get the new one
	cache[key] = query ?? ''
	localStorage.setItem(key, query ?? '')
}
